import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './Parent.module.scss';
import Actions from '../actions/Actions';
import { gql, useMutation } from '@apollo/client';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconChain from '../../../../assets/icons/link_chain.svg?react';
import IconExclamation from '../../../../assets/icons/exclamation_sign.svg?react';
import { useToast } from 'src/hooks/useToast';
import Button from 'src/components/button/Button';
import Spinner from 'src/components/spinner/Spinner';
import { useCourseContent } from '@hooks/useCourseContent';
import { logger } from '../../../../utils/logger';

type Props = {
  isFullScreen: boolean;
  skill: string;
  goBack?: () => void;
  isPreview?: boolean;
};

const generateAccessMutation = gql`
    mutation GenerateAccess($input: IDInput!) {
      generateAccess(input: $input)
    }
`;

type AccessResponse = {
  generateAccess: string;
}

function Parent(props: Props) {
  const {isFullScreen, skill, isPreview, goBack} = props;
  const [url, setUrl] = useState('');
  const {successToast} = useToast();
  const {lesson} = useCourseContent();

  const [generateAccess, {loading}] = useMutation<AccessResponse>(generateAccessMutation, {
    onError(err: any) {
      logger.debug(`[Error while generating access]`, err);
    },
    onCompleted(res) {
      setUrl(`${window.location.protocol}//${window.location.host}/parent/login?id=${res.generateAccess}`);
    }
  });

  useEffect(() => {
    if (skill) {
      generateAccess({
        variables: {
          input: { id: skill }
        }
      });
    }
  }, [generateAccess, skill]);

  const handleCopyToClipboard = useCallback((text: string) => {
    successToast(text);
  }, [successToast]);

  const title = useMemo(() => {
    if (lesson) {
      return lesson.name
    }
  }, [lesson])
  return (
    <Actions fullScreen={isFullScreen} className={"parent_app_generator"} isPreview={isPreview} goBack={goBack}>
      <div className={styles.content}>
        <div className={styles.topTitle}>
          {title}
        </div>
        <div className={styles.title}>
          Parent & Caregiver Resources
        </div>
        <div className={styles.url}>
          {loading ? <Spinner/> :
            <>
              <CopyToClipboard text={url} onCopy={() => handleCopyToClipboard('Link copied!')}>
                <div style={{margin: '0 auto', display: 'block'}}><Button
                    title={url}
                    className={styles.pulsedButton}
                    leftIcon={<IconChain width="20px" height="20px" className={styles.iconWrapper}/>}
                    label={' Click here to copy link'}/>
                </div>
              </CopyToClipboard>
              <div className={styles.descBlock}>
                <IconExclamation/>
                <div className={styles.descText}>Send this link to your students’ Parents & Caregivers<br/> To copy the
                  link, click the button above
                </div>
              </div>
            </>
          }
        </div>
        <div className={styles.description}>
          This unique URL provides parents access a short audio recording to help reinforce the skills your students are
          learning.
        </div>
      </div>
    </Actions>
  );
}

export default Parent;
